import "./src/styles/global.css"

const pushEvent = (event, params = {}) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}

const handleClick = (event) => {
  const link = event.target.closest("a")
  if (!link) return

  const href = link.getAttribute("href") || ""

  if (href.startsWith("tel:")) {
    pushEvent("phone_click", {
      event_category: "engagement",
      method: "phone",
      phone_number: href.replace(/^tel:/, ""),
    })
    return
  }

  if (href.startsWith("mailto:")) {
    pushEvent("email_click", {
      event_category: "engagement",
      method: "email",
    })
    return
  }

  if (href.includes("google.com/maps") || href.includes("maps.app.goo.gl")) {
    pushEvent("get_directions", {
      event_category: "engagement",
      method: "maps",
    })
  }
}

const handleCalendlyMessage = (event) => {
  if (event.origin !== "https://calendly.com") return
  if (event.data?.event !== "calendly.event_scheduled") return

  pushEvent("generate_lead", {
    event_category: "conversion",
    method: "calendly",
    lead_source: "book_appointment",
  })
}

export const onClientEntry = () => {
  window.dataLayer = window.dataLayer || []
  document.addEventListener("click", handleClick)
  window.addEventListener("message", handleCalendlyMessage)
}
